import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: "kn-page-content p-grid p-m-0" }
const _hoisted_3 = {
  key: 0,
  class: "p-col"
}
const _hoisted_4 = { class: "table-header" }
const _hoisted_5 = { class: "p-input-icon-left" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KnFabButton = _resolveComponent("KnFabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_KnOverlaySpinnerPanel = _resolveComponent("KnOverlaySpinnerPanel")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_CalendarManagementDialog = _resolveComponent("CalendarManagementDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('managers.calendarManagement.title')), 1)
      ]),
      end: _withCtx(() => [
        _withDirectives(_createVNode(_component_KnFabButton, {
          icon: "fas fa-plus",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showForm()))
        }, null, 512), [
          [_vShow, _ctx.canManageCalendar]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_KnOverlaySpinnerPanel, {
      visibility: _ctx.loading,
      "data-test": "spinner"
    }, null, 8, ["visibility"]),
    _createVNode("div", _hoisted_2, [
      (!_ctx.loading)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode(_component_DataTable, {
              value: _ctx.calendars,
              paginator: _ctx.calendars.length > 20,
              loading: _ctx.loading,
              rows: 20,
              class: "p-datatable-sm kn-table",
              dataKey: "id",
              filters: _ctx.filters,
              "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
              globalFilterFields: _ctx.calendarManagementDescriptor.globalFilterFields,
              responsiveLayout: "stack",
              breakpoint: "960px",
              onRowClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showForm($event))),
              "data-test": "calendar-table"
            }, {
              header: _withCtx(() => [
                _createVNode("div", _hoisted_4, [
                  _createVNode("span", _hoisted_5, [
                    _hoisted_6,
                    _createVNode(_component_InputText, {
                      class: "kn-material-input",
                      modelValue: _ctx.filters['global'].value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters['global'].value = $event)),
                      placeholder: _ctx.$t('common.search'),
                      "data-test": "search-input"
                    }, null, 8, ["modelValue", "placeholder"])
                  ])
                ])
              ]),
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
              ]),
              loading: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.info.dataLoading')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  class: "kn-truncated",
                  field: "calendar",
                  header: _ctx.$t('common.name'),
                  sortable: true
                }, null, 8, ["header"]),
                _createVNode(_component_Column, {
                  class: "kn-truncated",
                  field: "calStartDay",
                  header: _ctx.$t('cron.startDate'),
                  sortable: true
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode("span", {
                      "data-test": 'calendar-start-day-' + slotProps.data.calendar
                    }, _toDisplayString(_ctx.getFormattedDate(slotProps.data.calStartDay)), 9, ["data-test"])
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  class: "kn-truncated",
                  field: "calEndDay",
                  header: _ctx.$t('cron.endDate'),
                  sortable: true
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode("span", null, _toDisplayString(_ctx.getFormattedDate(slotProps.data.calEndDay)), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  class: "kn-truncated",
                  field: "calType",
                  header: _ctx.$t('common.type'),
                  sortable: true
                }, null, 8, ["header"]),
                (_ctx.canManageCalendar)
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 0,
                      style: _ctx.calendarManagementDescriptor.iconColumnStyle
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(_component_Button, {
                          icon: "pi pi-trash",
                          class: "p-button-link",
                          onClick: ($event: any) => (_ctx.deleteCalendarConfirm(slotProps.data)),
                          "data-test": 'delete-button-' + slotProps.data.calendar
                        }, null, 8, ["onClick", "data-test"])
                      ]),
                      _: 1
                    }, 8, ["style"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["value", "paginator", "loading", "filters", "globalFilterFields"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_CalendarManagementDialog, {
      visible: _ctx.calendarDialogVisible,
      propCalendar: _ctx.selectedCalendar,
      domains: _ctx.domains,
      onClose: _ctx.closeCalendarDialog,
      onCalendarSaved: _ctx.onCalendarSaved
    }, null, 8, ["visible", "propCalendar", "domains", "onClose", "onCalendarSaved"])
  ]))
}